module.exports = __webpack_public_path__ + "static/media/baisheng_640x360.6c75f36.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/baisheng_640x360.mp4
// module id = jZMx
// module chunks = 0